<div class="filters-section-heading">
  <span class="filters-section-heading__icon" aria-hidden="true">
    <i class="iconsax" [attr.icon-name]="icon()"></i>
  </span>
  <span class="filters-section-heading__text">
    {{ titleKey() | translate }}
  </span>
</div>
